
export default {
  props: {
    product: {
      type: Object,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idProductAttributeSelected: null,
    };
  },
  computed: {
    variants() {
      return this.product?.Variant || [];
    },
  },
  methods: {
    selectSize(variant) {
      this.idProductAttributeSelected =
        this.getCombination(variant).IdProductAttribute;
      this.$emit('onSelect', {
        variant,
        size: this.getSize(this.getCombination(variant))?.AttributeName,
        color: this.getColor(this.getCombination(variant))?.AttributeName,
      });
    },
    getCombination(variant) {
      try {
        const size = variant.Combination;
        return size;
      } catch (error) {}
      return null;
    },
    getSize(combination) {
      try {
        const size = combination.Attributes.find(
          (attribute) => attribute.GroupName === 'Size'
        );
        return size;
      } catch (error) {}
      return {};
    },
    getColor(combination) {
      try {
        const size = combination.Attributes.find(
          (attribute) => attribute.GroupName === 'Color'
        );
        return size;
      } catch (error) {}
      return {};
    },
  },
  mounted() {
    if (this.variants.length > 0 && this.product?.Type === 'e-giftcard') {
      this.selectSize(this.variants[0]);
    }
  },
};
